import Vue from 'vue'

// initial state
const state = {
	willsub: {}
}

// getters
const getters = {
}

// actions
const actions = {
	
}

// mutations
const mutations = {
	setform(state, data) {
		state.willsub = Object.assign(state.willsub, data)
	},
	clearform(state) {
		state.willsub = {}
	}
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/form.js